module.exports = __webpack_public_path__ + "static/img/vat@1x.bb3d3ec.png";


//////////////////
// WEBPACK FOOTER
// ./xcloud-client-components-web/assets/images/vat@1x.png
// module id = AaIC
// module chunks = 0